import { Component, ElementRef, HostBinding, HostListener, Injector, Input, OnChanges, Renderer2, SimpleChanges } from "@angular/core";
import { FoundationNavigationModule } from "@app/main/modules/foundation/foundation.navigation";
import { IVehicle } from "@interfaces/IVehicle";
import { NavigationService } from "@services/navigation.service";
import { PopupService } from "@services/popup.service";
import { VehicleService } from "@services/vehicle.service";
import "./vehicleReg.component.scss";

@Component({
    selector: "vehicle-reg",
    template: require("./vehicleReg.component.html")
})
export class VehicleRegComponent implements OnChanges {

    @Input() vehicle: IVehicle;
    @Input() vehicleId: number;
    @Input() allowNonDatabaseVehicle: boolean = false;

    @HostBinding("class.clickable") @Input() clickable = false;
    @HostListener("click", ["$event"]) onClick() { this.navigateToVehicle(); };

    // ---

    private appliedTrailerClass: boolean;
    private appliedNoVehicleClass: boolean;

    private primaryPlateText: string;
    private tooltipText: string;

    constructor(
        private readonly renderer: Renderer2,
        private readonly elementRef: ElementRef,
        private readonly popupService: PopupService,
        private readonly vehicleService: VehicleService,
        private readonly navigationService: NavigationService
    ) {
    }

    ngOnInit(): void {
        this.loadVehicle();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.loadVehicle();
    }

    showVehiclePopup($event: MouseEvent) {
        // Removed via MT request
        //this.showPopup($event);
    }

    hideVehiclePopup() {
        //this.showPopup();
    }

    // ---

    private loadVehicle(): void {
        if (!!this.vehicleId) {
            this.vehicle = {
                ShortReg: "...",
                Reg: "..."
            };

            this.vehicleService.getVehicleFromDatabase(this.vehicleId).then(vehicle => {
                this.vehicle = vehicle;
                this.vehicleUpdated();
            });
        }
        else {
            this.vehicleUpdated();
        }
    }

    private vehicleUpdated() {
        this.updateClasses();
        this.updateTextStrings();
    }

    private updateClasses() {
        if (this.vehicle?.Id || this.allowNonDatabaseVehicle) {
            var shouldApplyTrailerClass = this.vehicleService.isNonDrivableVehicleType(this.vehicle);

            this.applyTrailerClass(shouldApplyTrailerClass);
            this.applyNoVehicleClass(false);
        }
        else {
            this.vehicle = {
                ShortReg: "N/A",
                Reg: "N/A"
            };

            this.applyNoVehicleClass(true);
            this.applyTrailerClass(false);
        }
    }

    private applyTrailerClass(shouldApplyTrailerClass: boolean) {
        if (shouldApplyTrailerClass && !this.appliedTrailerClass) {
            this.addClass("trailer");
        }
        else if (!shouldApplyTrailerClass && this.appliedTrailerClass) {
            this.removeClass("trailer");
        }

        this.appliedTrailerClass = shouldApplyTrailerClass;
    }

    private applyNoVehicleClass(shouldApplyNoVehicleClass: boolean) {
        if (shouldApplyNoVehicleClass && !this.appliedNoVehicleClass) {
            this.addClass("no-vehicle");
        }
        else if (!shouldApplyNoVehicleClass && this.appliedNoVehicleClass) {
            this.removeClass("no-vehicle");
        }

        this.appliedNoVehicleClass = shouldApplyNoVehicleClass;
    }

    private addClass(className: string) {
        this.renderer.addClass(this.elementRef.nativeElement, className);
    }

    private removeClass(className: string,) {
        this.renderer.removeClass(this.elementRef.nativeElement, className);
    }

    private updateTextStrings() {
        // Set tooltips & plates
        this.primaryPlateText = this.vehicle.Reg;

        // If reg's are similar, then dont show both
        //console.log(this.vehicle.Reg, this.vehicle.ShortReg);
        if (this.vehicle.Reg.indexOf(this.vehicle.ShortReg) >= 0 || this.vehicle.ShortReg?.indexOf(this.vehicle.Reg) >= 0) {
            this.tooltipText = this.vehicle.Reg.length > this.vehicle.ShortReg.length
                ? this.vehicle.Reg
                : this.vehicle.ShortReg;

            if (this.tooltipText.length < 10) {
                this.tooltipText = null;
            }
        }
        else {
            this.tooltipText = "";
            if (this.primaryPlateText.length > 10) {
                this.tooltipText = `${this.vehicle.Reg} // `;
            }

            this.tooltipText += this.vehicle.ShortReg || "";
        }
    }
    
    private navigateToVehicle() {
        if (!this.clickable || !this.vehicle.Id) {
            return;
        }

        this.navigationService.go(FoundationNavigationModule.VehicleView, { vehicleId: this.vehicle.Id });
    }
}
